import * as yup from "yup";

import * as RHFAddressValidationRules from "@/utils/validation/schemas/address.RHF";

import { BPostAddressValidationSchema } from "../../../FormFields/BPostAddressField/bpostAddressField.schema";

export const DefaultAddressValidationSchema = yup
    .object({
        street: RHFAddressValidationRules.street,
        number: RHFAddressValidationRules.number,
        box: RHFAddressValidationRules.box,
        zipCode: RHFAddressValidationRules.zipCode,
        city: RHFAddressValidationRules.city,
        country: RHFAddressValidationRules.country,
        selected: RHFAddressValidationRules.selected,
        validationStatus: RHFAddressValidationRules.validationStatus,
        isComplete: yup.boolean().optional()
    })
    .concat(BPostAddressValidationSchema);

export type DefaultAddressFormValues = yup.InferType<
    typeof DefaultAddressValidationSchema
>;
